module.exports = __webpack_public_path__ + "img/b5-1.7909926.png";